/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description RenderAccountList
 */

import React from 'react';
import _ from 'lodash';
import { Button as AntButton, Typography } from 'antd';

import { Link } from 'react-router-dom';
import PaymentListTooltip from 'components/payments/common/PaymentListTooltip';
import { getAccountDetailsPath } from 'utils/router';

const RenderAccountList: React.FC<{
	accounts: Accounts.IListInfo[];
}> = ({ accounts }) => {
	return (
		<PaymentListTooltip
			title='Accounts'
			items={_.map(accounts, (item) => (
				<React.Fragment key={item.id}>
					<Link to={getAccountDetailsPath(item.id)}>{item?.accountNumber || 'No Account Number'}</Link>
					{item.accountAge && (
						<Typography.Text type='secondary' className='ml-1 text-nowrap'>{`(${item.accountAge} days)`}</Typography.Text>
					)}
				</React.Fragment>
			))}
			listItemClassName='items-baseline'
		>
			<AntButton type='link' className='overflow-hidden p-0 underline'>
				<span className='overflow-hidden text-ellipsis'>{_.size(accounts)}</span>
			</AntButton>
		</PaymentListTooltip>
	);
};

export default RenderAccountList;
